import React, { useState, useEffect } from "react";
import { FaClipboardList, FaTimes } from "react-icons/fa";
import "./attendance.css";
import api from "../../services/api";  
import AttendanceTable from "./AttendanceTable";
import LoadingSpinner from "../common/LoadingSpinner";

const AttendanceHistory = () => {
  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [holidays, setHolodays] = useState([]);
  const [leaves, setLeaves] = useState([]); // ✅ NEW: Approved leaves
  const [showLeaveModal, setShowLeaveModal] = useState(false); // ✅ NEW
  const [leaveForm, setLeaveForm] = useState({
    leave_date: "",
    leave_type: "casual",
    reason: ""
  });
  const [leaveSubmitting, setLeaveSubmitting] = useState(false); // ✅ NEW
  const [myLeaves, setMyLeaves] = useState([]); // ✅ NEW: My leave requests

  const handleGetHistory = async () => {
    try {
      setIsLoading(true);
      setErrorMsg("");
      
      const token = localStorage.getItem("token");
      const response = await api.get("/attendance/get_history", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (response.status === 200) {
        setRecords(response.data.records || []);
        setHolodays(response.data.holidays || []);
        setLeaves(response.data.leaves || []); // ✅ NEW: Approved leaves from backend
      }
    } catch (error) {
      console.log(`Something went wrong! ${error}`);
      setErrorMsg(error.response?.data?.message || "Failed to fetch attendance history");
      setRecords([]);
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ NEW: Fetch my leave requests
  const handleGetMyLeaves = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get("/user/my_leaves", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        setMyLeaves(response.data.leaves || []);
      }
    } catch (error) {
      console.error("Failed to fetch my leaves:", error);
    }
  };

  // ✅ NEW: Submit leave request
  const handleSubmitLeave = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    
    if (!leaveForm.leave_date || !leaveForm.leave_type) {
      setErrorMsg("Leave date and type are required");
      return;
    }
    
    try {
      setLeaveSubmitting(true);
      const token = localStorage.getItem("token");
      const response = await api.post("/user/leave_request", leaveForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.status === 201) {
        alert("Leave request submitted successfully!");
        setShowLeaveModal(false);
        setLeaveForm({ leave_date: "", leave_type: "casual", reason: "" });
        handleGetMyLeaves();
      }
    } catch (error) {
      setErrorMsg(error.response?.data?.message || "Failed to submit leave request");
      setTimeout(() => setErrorMsg(""), 4000);
    } finally {
      setLeaveSubmitting(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterChange = (e) => {
    setFilterMonth(e.target.value);
  };

  useEffect(() => {
    handleGetHistory();
    handleGetMyLeaves(); // ✅ NEW
  }, []);

  if (isLoading) {
    return (
      <div className="history-container">
        <div className="header-banner mb-4">
          <div className="header-content">
            <div>
              <h1 className="header-title">Attendance History </h1>
              <p className="header-subtitle">View your complete attendance records</p>
            </div>
          </div>
        </div>
        <LoadingSpinner message="Loading attendance records..." />
      </div>
    );
  }

  return (
    <div className="history-container">
      <div className="header-banner mb-4">
        <div className="header-content">
          <div>
            <h1 className="header-title">Attendance History </h1>
            <p className="header-subtitle">View your complete attendance records</p>
          </div>
          {/* ✅ NEW: Request Leave Button */}
          <button
            className="btn-add-student"
            onClick={() => setShowLeaveModal(true)}
            style={{ background: '#FFFFFF', color: '#667EEA' }}
          >
            <span className="btn-icon"><FaClipboardList /></span> Request Leave
          </button>
        </div>
      </div>

      {errorMsg && (
        <div className="error-message">{errorMsg}</div>
      )}

      {/* ✅ NEW: My Leave Requests Section */}
      {myLeaves.length > 0 && (
        <div className="students-card" style={{ marginBottom: '20px' }}>
          <div className="card-header-custom">
            <div>
              <h3 className="card-title">My Leave Requests</h3>
              <p className="card-subtitle">{myLeaves.length} leave request(s)</p>
            </div>
          </div>
          <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {myLeaves.map((leave) => (
              <div key={leave.id} style={{
                background: leave.status === 'approved' ? '#f0fdf4' : leave.status === 'rejected' ? '#fef2f2' : '#fffbeb',
                border: `1px solid ${leave.status === 'approved' ? '#bbf7d0' : leave.status === 'rejected' ? '#fecaca' : '#fde68a'}`,
                borderRadius: '8px',
                padding: '12px 16px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '8px'
              }}>
                <div>
                  <strong style={{ fontSize: '14px', color: '#1e293b' }}>
                    {new Date(leave.leave_date).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
                  </strong>
                  <span style={{ fontSize: '12px', color: '#64748b', marginLeft: '8px', textTransform: 'capitalize' }}>
                    {leave.leave_type}
                  </span>
                </div>
                <span style={{
                  padding: '4px 12px',
                  borderRadius: '20px',
                  fontSize: '11px',
                  fontWeight: '600',
                  textTransform: 'capitalize',
                  background: leave.status === 'approved' ? '#d4edda' : leave.status === 'rejected' ? '#f8d7da' : '#fff3cd',
                  color: leave.status === 'approved' ? '#155724' : leave.status === 'rejected' ? '#721c24' : '#856404'
                }}>
                  {leave.status}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ✅ NEW: Leave Request Modal */}
      {showLeaveModal && (
        <div className="modal-overlay" onClick={() => setShowLeaveModal(false)}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-custom">
              <div>
                <h3 className="modal-title">Request Leave</h3>
                <p className="modal-subtitle">Submit a leave request for admin approval</p>
              </div>
              <button className="modal-close" onClick={() => setShowLeaveModal(false)} aria-label="Close leave request modal"><FaTimes /></button>
            </div>
            <div className="modal-body-custom">
              <form onSubmit={handleSubmitLeave}>
                <div className="form-group">
                  <label className="form-label">Leave Date</label>
                  <input
                    type="date"
                    className="form-input"
                    value={leaveForm.leave_date}
                    onChange={(e) => setLeaveForm({ ...leaveForm, leave_date: e.target.value })}
                    min={new Date().toISOString().split('T')[0]}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Leave Type</label>
                  <select
                    className="form-input"
                    value={leaveForm.leave_type}
                    onChange={(e) => setLeaveForm({ ...leaveForm, leave_type: e.target.value })}
                    required
                  >
                    <option value="casual">Casual Leave</option>
                    <option value="sick">Sick Leave</option>
                    <option value="emergency">Emergency Leave</option>
                    <option value="personal">Personal Leave</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Reason (Optional)</label>
                  <textarea
                    style={{resize: "none"}}
                    className="form-input"
                    rows="3"
                    placeholder="Enter reason for leave..."
                    value={leaveForm.reason}
                    onChange={(e) => setLeaveForm({ ...leaveForm, reason: e.target.value })}
                  />
                </div>
                <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '20px' }}>
                  <button type="button" className="btn-cancel" onClick={() => setShowLeaveModal(false)}>Cancel</button>
                  <button type="submit" className="btn-submit" disabled={leaveSubmitting}>
                    {leaveSubmitting ? "Submitting..." : "Submit Request"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <AttendanceTable
        records={records}
        searchTerm={searchTerm}
        filterMonth={filterMonth}
        onSearchChange={handleSearchChange}
        onFilterChange={handleFilterChange}
        holidays={holidays}
        leaves={leaves} // ✅ NEW: Pass approved leaves
      />
    </div>
  );
};

export default AttendanceHistory;